export default __webpack_public_path__ + "08ebb8e3fd0003f186663575095e9f0c.png";